<template>
    <!-- <div class="sa-tab-scroll"> -->
    <b-tabs id="tabsSchede" nav-wrapper-class="sa-tab-items" content-class="mt-3" ref="tabs" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill>
        <b-tab :title="'Dettaglio'" active>
            <div class="sa-tab-scroll">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <b-card class="sa-card" header="Articolo" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Codice Articolo:</label>
                                    <b-form-input v-model="jsonData.codice" placeholder="Codice Articolo"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Descrizione:</label>
                                    <b-form-input v-model="jsonData.descrizione" placeholder="Descrizione"></b-form-input>
                                </b-col>
                                <!--<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Fornitore:</label>
                        <b-form-input v-model="jsonData.codiceFornitore" placeholder="Codice Fornitore"></b-form-input>
                    </b-col>-->
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Fornitore:</label>
                                    <b-form-select v-model="jsonData.codiceFornitore" :options="fornitoriOptions" :value="null" value-field="codice" text-field="nominativo" @change="onChangeFornitore"> </b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Esposto Listino:</label>
                                    <b-form-input v-model="jsonData.espostoListino" placeholder="Esposto Listino"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Listino:</label>
                                    <b-form-input v-model="jsonData.descrizioneListino" placeholder="Listino"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">IVA:</label>
                                    <b-form-select v-model="jsonData.codiceIva" :options="ivaOptions" :value="null" value-field="codice" text-field="descrizione" @change="onChangeIva"> </b-form-select>
                                </b-col>
                                <!-- <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">IVA Descrizione:</label>
                        <b-form-input v-model="jsonData.descrizioneIva" placeholder="IVA Descrizione"></b-form-input>
                    </b-col> -->
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Aliquota IVA:</label>
                                    <b-form-input v-model="jsonData.aliquotaIva" placeholder="Aliquota IVA" disabled></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Gruppo:</label>
                                    <b-form-select v-model="jsonData.gruppo" :options="gruppiOptions" :value="null" value-field="codice" text-field="descrizione"> </b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Marca:</label>
                                    <b-form-select v-model="jsonData.marca" :options="marcheOptions" :value="null" value-field="value" text-field="text"> </b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Unita Misura:</label>
                                    <b-form-select v-model="jsonData.unitaMisura" :options="unitaMisuraOptions" :value="null" value-field="codice" text-field="descrizione" @change="onChangeUnitaMisura"> </b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Deposito:</label>
                                    <b-form-select v-model="jsonData.deposito" :options="depositiOptions" :value="null" value-field="codice" text-field="descrizione"> </b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Escluso Utile:</label>
                                    <b-form-input v-model="jsonData.esclusoUtile" placeholder="Escluso Utile"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Q.ta Confezione:</label>
                                    <b-form-input v-model="jsonData.quantitaConfezione" placeholder="Q.ta Confezione"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Q.ta Sotto Cartone:</label>
                                    <b-form-input v-model="jsonData.quantitaSottoCartone" placeholder="Q.ta Sotto Cartone"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Q.ta Cartone:</label>
                                    <b-form-input v-model="jsonData.quantitaCartone" placeholder="Q.ta Cartone"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Q.ta Pedana:</label>
                                    <b-form-input v-model="jsonData.quantitaPedana" placeholder="Q.ta Pedana"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Q.ta Scorta Minima:</label>
                                    <b-form-input v-model="jsonData.quantitaScortaMinima" placeholder="Q.ta Scorta Minima"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                                    <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                                        <label class="sa-label-data">Attivo</label>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <b-card class="sa-card" header="Listino" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">Data/Ora</label>
                                    <date-picker v-model="jsonData.listino.dataOra" format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime" disabled></date-picker>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">Costo Ultimo Acquisto</label>
                                    <b-form-input v-model="jsonData.listino.costoUltimoAcquisto" type="number" placeholder="Costo Ultimo Acquisto"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label_data">Valore Medio Ponderato</label>
                                    <b-form-input v-model="jsonData.listino.valoreMedioPonderataGiacenza" type="number" placeholder="Valore Medio Ponderato"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label_data">Prezzo Base</label>
                                    <b-form-input v-model="jsonData.listino.prezzoBase" type="number" placeholder="Prezzo Base"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label_data">Prezzo Esposto</label>
                                    <b-form-input v-model="jsonData.listino.prezzoEsposto" type="number" placeholder="Prezzo Esposto"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">L1</label>
                                    <b-form-input v-model="jsonData.listino.l1" type="number" placeholder="L1"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">L2</label>
                                    <b-form-input v-model="jsonData.listino.l2" type="number" placeholder="L2"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">L3</label>
                                    <b-form-input v-model="jsonData.listino.l3" type="number" placeholder="L3"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">L4</label>
                                    <b-form-input v-model="jsonData.listino.l4" type="number" placeholder="L4"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">LR1</label>
                                    <b-form-input v-model="jsonData.listino.lr1" type="number" placeholder="LR1"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">LR2</label>
                                    <b-form-input v-model="jsonData.listino.lr2" type="number" placeholder="LR2"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">LR3</label>
                                    <b-form-input v-model="jsonData.listino.lr3" type="number" placeholder="LR3"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label_data">LR4</label>
                                    <b-form-input v-model="jsonData.listino.lr4" type="number" placeholder="LR4"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-card class="sa-card" header="Dettaglio" header-tag="header" footer-tag="footer" title="">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaGiacenze" :key="listKey" :fields="fieldsGiacenze" :current-page="1" :per-page="100000" sort-icon-left head-variant="light">
                                <template v-slot:cell(tipo)="{ item }">
                                    <span class="sa-label-data" v-if="item.tipo === 'P'">PRINCIPALE</span>
                                    <span class="sa-label-data" v-if="item.tipo === 'A'">ARCHIVIO</span>
                                </template>
                                <template v-slot:cell(unitaMisura)="{ item }">
                                    <b-form-select v-model="item.unitaMisura" :options="unitaMisuraOptions" :value="null" value-field="codice" text-field="descrizione" disabled> </b-form-select>
                                </template>
                                <template v-slot:cell(quantita)="{ item }">
                                    <b-form-input v-model="item.quantita" placeholder="Quantita" type="number"></b-form-input>
                                </template>
                                <template v-slot:cell(descrizione)="{ item }">
                                    <b-form-input v-model="item.descrizione" placeholder="Descrizione"></b-form-input>
                                </template>
                                <template v-slot:cell(note)="{ item }">
                                    <b-form-textarea v-model="item.note" placeholder="Note" rows="2"></b-form-textarea>
                                </template>
                            </b-table>
                        </b-card>
                    </b-col>
                    <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                       
                    </b-col> -->
                </b-row>
            </div>
        </b-tab>
        <b-tab :title="'Barcode'">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-card class="sa-card" header="Barcode" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaBarcode" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                                    <template #cell(index)="row">
                                        {{ row.index + 1 }}
                                    </template>
                                    <template #cell(barcode)="item">
                                        <span v-if="item.index !== jsonData.listaBarcode.length - 1">{{ item.item.barcode }}</span>
                                        <b-form-input v-if="item.index === jsonData.listaBarcode.length - 1" v-model="item.item.barcode" placeholder="Codice"></b-form-input>
                                    </template>
                                    <template v-slot:cell(attivo)="{ item }">
                                        <b-form-checkbox v-if="!nuovo" v-model="item.attivo" name="check-button" switch></b-form-checkbox>
                                    </template>
                                    <template #cell(actions)="row">
                                        <b-button v-if="row.index === jsonData.listaBarcode.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAdd(jsonData.listaBarcode, row.item)">
                                            <b-icon icon="plus"></b-icon>
                                        </b-button>
                                        <b-button v-if="row.index !== jsonData.listaBarcode.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonData.listaBarcode, row)">
                                            <b-icon icon="trash"></b-icon>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-tab>
        <modal-error ref="cmpModalError"></modal-error>
    </b-tabs>

    <!-- </div> -->
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
import axios from "axios";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError, DatePicker },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            pathResource: "/articoli",
            pathFornitori: "/anagrafica",
            pathIva: "/iva",
            pathGruppi: "/articoligruppi",
            pathMarche: "/marche",
            pathUnitaMisura: "/unitamisura",
            pathDepositi: "/depositi",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            pathResourceBarcode: "/barcode/check/",
            nuovo: false,
            titoloModal: "",
            listKey: 0,
            fornitoriOptions: [],
            ivaOptions: [],
            gruppiOptions: [],
            marcheOptions: [],
            unitaMisuraOptions: [],
            depositiOptions: [],
            tipoAnagraficaOptions: [],
            jsonData: {
                codice: null,
                descrizione: null,
                fornitore: null,
                codiceFornitore: null,
                descrizioneFornitore: null,
                espostoListino: null,
                descrizioneListino: null,
                codiceIva: null,
                gruppo: null,
                marca: null,
                unitaMisura: null,
                deposito: null,
                esclusoUtile: null,
                quantitaConfezione: 0,
                quantitaSottoCartone: 0,
                quantitaCartone: 0,
                quantitaPedana: 0,
                quantitaScortaMinima: 0,
                attivo: true,
                descrizioneIva: null,
                aliquotaIva: 0,
                listaBarcode: [],
                listino: {
                    idArticolo: null,
                    dataOra: new Date().getTime(),
                    costoUltimoAcquisto: null,
                    valoreMedioPonderataGiacenza: 0,
                    prezzoBase: 0,
                    prezzoEsposto: 0,
                    l1: 0,
                    l2: 0,
                    l3: 0,
                    l4: 0,
                    lr1: 0,
                    lr2: 0,
                    lr3: 0,
                    lr4: 0,
                },
                listaGiacenze: [],
            },
            fieldsGiacenze: [
                {
                    label: "Tipo",
                    key: "tipo",
                    thStyle: "width: 7rem",
                    sortable: true,
                },
                {
                    label: "Unita Misura",
                    key: "unitaMisura",
                    thStyle: "width: 10rem",
                    sortable: true,
                },
                {
                    label: "Giacenza",
                    key: "quantita",
                    thStyle: "width: 9rem",
                    sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    // thStyle: "width: 15rem",
                    sortable: true,
                },
                {
                    label: "Note",
                    key: "note",
                    thStyle: "width: 30rem",
                    sortable: true,
                },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Codice",
                    key: "barcode",
                    // thStyle: "width: 20rem",
                    // sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        onChangeUnitaMisura() {
            let me = this;
            // me.jsonData.unitaMisura
            me.jsonData.listaGiacenze.forEach((element) => {
                element.unitaMisura = me.jsonData.unitaMisura;
            });
        },
        init(id) {
            let me = this;
            me.$emit("beforloadData");
            if (id !== "-1") {
                me.nuovo = false;
                me.titoloModal = "Modifica Articolo";
                // me.jsonData = item;
                me.loadData(id);
            } else {
                me.nuovo = true;
                me.titoloModal = "Aggiungi Articolo";
                me.jsonData = {
                    codice: null,
                    descrizione: null,
                    fornitore: null,
                    codiceFornitore: null,
                    descrizioneFornitore: null,
                    espostoListino: null,
                    descrizioneListino: null,
                    codiceIva: null,
                    gruppo: null,
                    marca: null,
                    unitaMisura: null,
                    deposito: null,
                    esclusoUtile: null,
                    quantitaConfezione: 0,
                    quantitaSottoCartone: 0,
                    quantitaCartone: 0,
                    quantitaPedana: 0,
                    quantitaScortaMinima: 0,
                    attivo: true,
                    descrizioneIva: null,
                    aliquotaIva: 0,
                    listaBarcode: [],
                    listino: {
                        idArticolo: null,
                        dataOra: new Date().getTime(),
                        costoUltimoAcquisto: null,
                        valoreMedioPonderataGiacenza: 0,
                        prezzoBase: 0,
                        prezzoEsposto: 0,
                        l1: 0,
                        l2: 0,
                        l3: 0,
                        l4: 0,
                        lr1: 0,
                        lr2: 0,
                        lr3: 0,
                        lr4: 0,
                    },
                    listaGiacenze: [],
                };
                me.checkGiacenze();
                me.jsonData.listaBarcode.push({ barcode: null, attivo: true });
            }
            me.loadFornitori();
            me.loadIva();
            me.loadGruppi();
            me.loadMarche();
            me.loadUnitaMisura();
            me.loadDepositi();
            // me.$refs.mdlNuovaAnagrafica.show();
            me.$emit("afterLoadData");
        },
        loadData(id) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + id;
            UtilityMixin.methods.restCallGet(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
            me.jsonData.listaBarcode.push({ barcode: null, attivo: true });
        },
        loadDataError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        checkGiacenze() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/giacenze";
            UtilityMixin.methods.restCallGet(link, null, me.checkGiacenzeSuccess, me.checkGiacenzeError);
        },
        checkGiacenzeSuccess(response) {
            let me = this;
            me.jsonData.listaGiacenze = response.data.data;
            me.listKey++;
        },
        checkGiacenzeError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "ANAGRAFICA";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadTipiAnagraficaSuccess, me.loadTipiAnagraficaError);
        },
        loadTipiAnagraficaSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadTipiAnagraficaError(response) {
            console.log(response);
        },
        loadFornitori() {
            let me = this;
            let filtro = { codiceTipo: "FOR" };
            UtilityMixin.methods.loadDataResources(me.pathFornitori, filtro, me.loadFornitoriSuccess, me.loadFornitoriError);
        },
        loadFornitoriSuccess(response) {
            let me = this;
            me.fornitoriOptions = response.data.data.list;
            me.fornitoriOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadFornitoriError(response) {
            console.log(response);
        },
        loadIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathIva, null, me.loadIvaSuccess, me.loadIvaError);
        },
        loadIvaSuccess(response) {
            let me = this;
            me.ivaOptions = response.data.data.list;
            me.ivaOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadIvaError(response) {
            console.log(response);
        },
        loadGruppi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathGruppi, null, me.loadGruppiSuccess, me.loadGruppiError);
        },
        loadGruppiSuccess(response) {
            let me = this;
            me.gruppiOptions = response.data.data.list;
            me.gruppiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadGruppiError(response) {
            console.log(response);
        },
        loadMarche() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathMarche, null, me.loadMarcheSuccess, me.loadMarcheError);
        },
        loadMarcheSuccess(response) {
            let me = this;
            me.marcheOptions = [];
            response.data.data.list.forEach((element) => {
                me.marcheOptions.push({ value: element.descrizone, text: element.descrizone });
            }),
                me.marcheOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadMarcheError(response) {
            console.log(response);
        },
        loadUnitaMisura() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathUnitaMisura, null, me.loadUnitaMisuraSuccess, me.loadUnitaMisuraError);
        },
        loadUnitaMisuraSuccess(response) {
            let me = this;
            me.unitaMisuraOptions = response.data.data.list;
            me.unitaMisuraOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadUnitaMisuraError(response) {
            console.log(response);
        },
        loadDepositi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathDepositi, null, me.loadDepositiSuccess, me.loadDepositiError);
        },
        loadDepositiSuccess(response) {
            let me = this;
            me.depositiOptions = response.data.data.list;
            me.depositiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadDepositiError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = {
                codice: null,
                descrizione: null,
                fornitore: null,
                codiceFornitore: null,
                descrizioneFornitore: null,
                espostoListino: null,
                descrizioneListino: null,
                codiceIva: null,
                gruppo: null,
                marca: null,
                unitaMisura: null,
                deposito: null,
                esclusoUtile: null,
                quantitaConfezione: 0,
                quantitaSottoCartone: 0,
                quantitaCartone: 0,
                quantitaPedana: 0,
                quantitaScortaMinima: 0,
                attivo: true,
                descrizioneIva: null,
                aliquotaIva: 0,
                listaBarcode: [],
                listino: {
                    idArticolo: null,
                    dataOra: new Date().getTime(),
                    costoUltimoAcquisto: null,
                    valoreMedioPonderataGiacenza: 0,
                    prezzoBase: 0,
                    prezzoEsposto: 0,
                    l1: 0,
                    l2: 0,
                    l3: 0,
                    l4: 0,
                    lr1: 0,
                    lr2: 0,
                    lr3: 0,
                    lr4: 0,
                },
                listaGiacenze: [],
            };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaAnagrafica.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
        onChangeFornitore() {
            let me = this;
            me.fornitoriOptions.forEach((element) => {
                if (element.codice === me.jsonData.codiceFornitore) {
                    me.jsonData.descrizioneFornitore = element.nominativo;
                    console.log(me.jsonData.descrizioneFornitore);
                }
            });
        },
        onChangeIva() {
            let me = this;
            me.ivaOptions.forEach((element) => {
                if (element.codice === me.jsonData.codiceIva) {
                    me.jsonData.descrizioneIva = element.descrizione;
                    me.jsonData.aliquotaIva = element.aliquota;
                }
            });
        },
        checkBarcode(barcode) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceBarcode + barcode;
            axios
                .get(link)
                .then(() => {
                    return false;
                })
                .catch(() => {
                    return true;
                });
        },
        onAdd(array, value) {
            let me = this;
            if (value.barcode) {
                let link = process.env.VUE_APP_PATH_API + me.pathResourceBarcode + value.barcode;
                axios
                    .get(link)
                    .then(() => {
                        this.$bvModal
                            .msgBoxOk("Il Barcode già è presente", {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    })
                    .catch(() => {
                        array.push({ barcode: null, attivo: true });
                    });
            } else {
                this.$bvModal
                    .msgBoxOk("Il campo Codice e' OBBLIGATORIO", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {
                        // console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>
